import { render, staticRenderFns } from "./LoginSchool.vue?vue&type=template&id=646d72aa&scoped=true"
import script from "./LoginSchool.vue?vue&type=script&lang=js"
export * from "./LoginSchool.vue?vue&type=script&lang=js"
import style0 from "./LoginSchool.vue?vue&type=style&index=0&id=646d72aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646d72aa",
  null
  
)

export default component.exports